import firebase from 'firebase/app';
import 'firebase/storage';
import moment from 'moment';
import config from '../../config';

const FIREBASE_CONFIG = {
    apiKey: config.FIREBASE_API_KEY,
    authDomain: config.FIREBASE_AUTHDO_MAIN,
    storageBucket: config.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: config.FIREBASE_MESSAGING_SENDER_ID
}

export const uploadFile = (obj) => {
    if(obj){
        if (!firebase.apps.length) { firebase.initializeApp(FIREBASE_CONFIG); }
        try{
            let file        = generateFileName() + '.'+ obj.type.split("/")[1];
            let storageRef  = firebase.storage().ref();
            let uploadTask  = storageRef.child(file).put(obj);
            return uploadTask;
        }catch(err){console.log(err);}
    }
}

export const removeFile = (url) => {
    if(url){
        if (!firebase.apps.length) { firebase.initializeApp(FIREBASE_CONFIG); }
        try{
            let storage     = firebase.storage();
            let fullPath    = storage.refFromURL(url).fullPath;
            storage.ref().child(fullPath).delete();
        }catch(err){ console.log(err) };

    }
}

export const generateFileName = () => {
    let current = moment().unix();
    let rand    = Math.floor(Math.random() * 100) + 1; // sometime user upload the same, so must to random to uniq name
    current     = current.toString();
    rand        = rand.toString();
    return current.concat(rand);
}